import { translations } from "../translations";

const refinementListTemplates = {
    item({ cssClasses, value, isRefined, count, label }, { html }) {
        return html`<label class="${cssClasses.label}">
            <input type="checkbox"
                class="${cssClasses.checkbox}"
                value="${value}"
                checked="${isRefined}"
            />
            <span class="${cssClasses.labelText}">${label}</span>
            <span class="${cssClasses.count}" title="${translations.refinementListCountTitle}">
                ${count.toLocaleString()}
            </span>
        </label>`;
    },
    showMoreText({ isShowingMore }, { html }) {
        return html`${isShowingMore
            ? translations.refinementListShowLessLabel
            : translations.refinementListShowMoreLabel}
        `;
    },
}

export default refinementListTemplates;
